<div class="get_started_box">
    <h2 class="h2 mb-4 text-capitalize">Connect your loved ones in one safe place, Family central.</h2>
    <form [formGroup]="emailForm">
        <div class="form-group get_started_field">
            <input type="email" name="email" id="email" class="form-control" placeholder="Enter your email address" formControlName="email">
            <button type="submit" class="primary_btn" (click)="goToOnboard()">Sign up</button>
        </div>
    </form>
</div>